import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import { ChartData } from '../../../ui/charts/doughnut/doughnut-chart.component';
import { DownloadHelper } from '../../../utils/download-helper';
import {
    EvaluateFeeUseCase,
    FeeInterface,
    GetContractUseCase,
    GetModelPdfUseCase,
    GetValidModelsUseCase,
    IdInterface,
    SetFeeUseCase,
    TypeDistributionInterface,
    ValidModelInterface,
} from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { Fee } from '../../../domain/data';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { TestPage } from '../test.page';

@Component({
    templateUrl: './test-rate.page.html',
    styleUrls: ['./test-rate.page.scss'],
})
export class TestRatePage extends BasePage implements AfterViewInit, OnInit {
    public chartData: ChartData[] = [];
    public fee: FeeInterface;
    public feedAmount = 0;
    public validModels: ValidModelInterface[] = [];

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private evaluateFeeUseCase: EvaluateFeeUseCase,
        private getContractUseCase: GetContractUseCase,
        private getModelPDFUseCase: GetModelPdfUseCase,
        private getValidModelsUseCase: GetValidModelsUseCase,
        private setFeeUseCase: SetFeeUseCase,
        private router: Router,
        private testPage: TestPage
    ) {
        super(parentEvents);
        this.testPage.showBack = true;
        this.testPage.back.subscribe(() => {
            this.router.navigateByUrl(MainRoutes.TEST_TRANSFER);
        });
    }

    ngOnInit() {
        this.getContract();
        this.getValidModels();
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.fee = new Fee(transaction.data.transfer.total);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getValidModels() {
        this.getValidModelsUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.validModels = transaction.data;
                if (!this.validModels.length) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: 'error.not-models-found' },
                    });
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    onChangeDistributions(data: TypeDistributionInterface[]) {
        setTimeout(() => {
            this.chartData = data.map((type) => ({
                name: type.name,
                value: type.value,
                weight: type.weight,
            }));
        }, 1);
    }

    onDownload(modelId: IdInterface) {
        this.getModelPDFUseCase.bind({ id: modelId }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                DownloadHelper.downloadBase64(transaction.data.content, transaction.data.name);
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onEvaluateFee(fee: FeeInterface) {
        this.fee = fee;
        this.evaluateFeeUseCase.bind({ data: fee }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.feedAmount = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }

    onSubmit() {
        if (this.fee?.isComplete()) {
            this.setFeeUseCase.bind({ data: this.fee }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(MainRoutes.FULL_DATA);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
        }
    }
}
